jQuery('#bigScreenOnRightContent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true,
    appendDots: jQuery('#bigScreenOnRightContentDots'),
});

jQuery('.staggered-content-big-screen-on-right .hotspot').click(function() {
    console.log('click');
    console.log(jQuery('.staggered-content-big-screen-on-right .image-container').attr('data-status'));

    switch (jQuery('.staggered-content-big-screen-on-right .image-container').attr('data-status')) {
        case 'on':
            jQuery('.staggered-content-big-screen-on-right .image-container').attr('data-status', 'off');

            break;
        case 'off':
            jQuery('.staggered-content-big-screen-on-right .image-container').attr('data-status', 'on');

            break;
    }
});

jQuery(document).ready(function() {
    if (jQuery(window).width() < 768) {
        jQuery('.staggered-content-big-screen-on-right .image-container').insertBefore('.staggered-content-big-screen-on-right .slider-container');
    }
});